import React from 'react';

import { ThreeDStockProductsCompactListItemPreviewProduct } from './ThreeDStockProductsCompactListItemPreview.types';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import { Icon } from '../../../../../../../helpers/Icon';
import {
  ImageHelper,
  ImageItemImageVersions
} from '../../../../../../../helpers/ImageHelper';

import { Files } from '../../../../../../../utils/Files';
import { PureIconButtonHelper } from '../../../../../../../helpers/buttons/PureIconButtonHelper';

const srcSetVersions = {
  '1x': ImageItemImageVersions.MiniThumb320x320,
  '2x': ImageItemImageVersions.MiniThumb640x640,
  '3x': ImageItemImageVersions.MiniThumb960x960
};

interface ThreeDStockProductsCompactListItemPreviewProps {
  product: ThreeDStockProductsCompactListItemPreviewProduct;
  onLightboxOpen: () => void;
}

function ThreeDStockProductsCompactListItemPreview({
  product,
  onLightboxOpen
}: ThreeDStockProductsCompactListItemPreviewProps) {
  return (
    <div className="relative shrink-0 z-10">
      {product.image?.file && Files.isImage(product.image?.file) ? (
        <ImageHelper
          className="object-cover w-20 h-20 bg-gray-200 dark:bg-gray-700 rounded-lg"
          src={product.image.file}
          version={ImageItemImageVersions.MiniThumb320x320}
          srcSetVersions={srcSetVersions}
          alt={product.name}
        />
      ) : (
        <div className="flex items-center justify-center text-gray-600 absolute inset-0">
          <Icon icon={IconsEnum.PHOTOGRAPH_OUTLINE} className="h-12 w-12" />
        </div>
      )}

      <PureIconButtonHelper
        className="group/expand absolute -inset-px flex items-center justify-center rounded-lg bg-black/80 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100"
        iconClassName="stroke-2 h-8 w-8 group-hover/expand:scale-125 transition-transform duration-150 ease-out"
        icon={IconsEnum.ARROWS_EXPAND_OUTLINE}
        onClick={onLightboxOpen}
      />
    </div>
  );
}

export default ThreeDStockProductsCompactListItemPreview;
